import type { Deal, Promo } from '../types/Deal';

const flags = [
  'black-friday',
  'cyber-monday',
  'seasonal',
  'recommended',
  'popular',
  'exclusive',
  'prime',
  'editors-pick',
  'limited-stock',
  'was-price',
  'was-price-light',
];

/**
 * Return promos that are considered as being flags
 */
const getFlagPromos = (deal: Partial<Deal>): Promo[] => {
  return (deal.promos ?? []).filter((promo) => flags.includes(promo.type));
};

/**
 * Return promos that are NOT considered as being flags (e.g. deal text)
 */
export const getNonFlagPromos = (deal: Partial<Deal>): Promo[] => {
  return (deal.promos ?? []).filter((promo) => !flags.includes(promo.type));
};

const getFirstPromoByType = (deal: Partial<Deal>, type: string): Promo[] => {
  return (deal.promos ?? []).filter((promo) => promo.type === type).slice(0, 1);
};

export const getPromos = (deal: Partial<Deal>, type: string): Promo[] => {
  const promos = ((): Promo[] => {
    switch (type) {
      case 'allowed':
        return deal.promos ?? [];
      case 'flags':
        return getFlagPromos(deal);
      case 'nonFlags':
        return getNonFlagPromos(deal);
      default:
        return getFirstPromoByType(deal, type);
    }
  })();

  return promos;
};
